import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { Logo } from "./Logo";
import { StatusDot } from "../ui";
import { FOOTER } from "../../data/nav";
import { useCurrency } from "../../lib/currency";
import { post } from "../../lib/api";

export function Footer({ settings }) {
  const { currency, setCurrency } = useCurrency();
  const navigate = useNavigate();
  const clicks = useRef({ n: 0, t: 0 });
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const secret = () => {
    const now = Date.now();
    clicks.current = now - clicks.current.t < 2000 ? { n: clicks.current.n + 1, t: now } : { n: 1, t: now };
    if (clicks.current.n >= 5) { clicks.current = { n: 0, t: 0 }; navigate("/admin"); }
  };
  const subscribe = async (e) => {
    e.preventDefault();
    try { const r = await post("/newsletter", { email, source_page: "footer" }); setMsg(r.message); setEmail(""); }
    catch (err) { setMsg(err?.response?.data?.detail || "Please enter a valid email."); }
  };
  return (
    <footer className="border-t border-line bg-surface">
      <div className="container-bc py-16">
        <div className="grid gap-10 lg:grid-cols-[1.3fr,2.7fr]">
          <div>
            <button onClick={secret} aria-label="BloomCONNECT" className="inline-flex" title="BloomCONNECT">
              <Logo variant="lockup" to={null} />
            </button>
            <p className="mt-4 text-sm text-ink-600 max-w-xs">The AI sales agent that qualifies leads, answers questions and books appointments across WhatsApp, Instagram, Messenger, Telegram, Email, web chat and SMS.</p>
            <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-sm">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="you@company.com" aria-label="Email address" className="flex-1 rounded-xs border border-line px-3 h-10 text-sm bg-white" />
              <button type="submit" className="btn-primary btn-md">Subscribe</button>
            </form>
            {msg && <p className="mt-2 text-xs text-brand-700">{msg}</p>}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {FOOTER.map((col) => (
              <div key={col.title}>
                <div className="eyebrow mb-4">{col.title}</div>
                <ul className="space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label + l.href}>
                      {l.external ? (
                        <a href={l.href} className="text-sm text-ink-600 hover:text-ink-950">{l.label}</a>
                      ) : (
                        <Link to={l.href} className="text-sm text-ink-600 hover:text-ink-950">{l.label}</Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-line flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-xs text-ink-400 space-y-1">
            <p>© 2026 Bloom DevLabs Corp. BloomCONNECT is a product of Bloom DevLabs Corp.</p>
            <p>Bloom DevLabs Corp. · Makati City, Philippines</p>
            <p className="flex items-center gap-1.5 text-ink-500" data-testid="footer-paypal-note">
              <CreditCard className="h-3.5 w-3.5" /> Accept Credit/Debit cards via PayPal
            </p>
          </div>
          <div className="flex items-center gap-5">
            <a href="https://www.paypal.com/myaccount/autopay/" target="_blank" rel="noreferrer" className="text-xs text-ink-500 hover:text-ink-950" data-testid="manage-billing-link">Manage billing</a>
            <StatusDot label={settings?.status_text || "All systems operational"} />
            <div className="flex items-center rounded-xs border border-line overflow-hidden" role="group" aria-label="Currency">
              {["PHP", "USD"].map((c) => (
                <button key={c} onClick={() => setCurrency(c)} className={`px-2.5 py-1 font-mono text-2xs ${currency === c ? "bg-ink-950 text-white" : "text-ink-600"}`}>{c}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
